import * as React from 'react';
import styled from 'styled-components';
import { Entity } from '../../../data/types';
import { logoString } from './PlaceHolderLogo';

interface IProps {
  title: string;
  entity: Entity;
  templateName?: string;
  timeframe: string;
}

/**
 * @description creates data URL
 * @param url
 * @param callback
 */
const toDataUrl = (url: string, callback?: (file: string) => void): void => {
  const xhr = new XMLHttpRequest();
  xhr.onload = (): void => {
    const reader = new FileReader();
    if (callback) {
      reader.onloadend = (): void => {
        callback(reader.result as string);
      };
    }

    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
};

export const PdfHeader = (props: IProps): React.ReactElement => {
  const [logoDataUrl, setLogoDataUrl] = React.useState<string>('');

  React.useEffect(() => {
    if (!props.entity) return;
    toDataUrl(props.entity?.image, setLogoDataUrl);
  }, [props.entity?.id]);

  return (
    <PdfHeaderWrapper id='pdf-header'>
      {!!props.entity ? (
        <ContentContainer>
          <ReportLogo
            src={`${props?.entity.image ? logoDataUrl : logoString}`}
          />
          <EntityContainer>
            <Name>
              {props?.entity.name ? props?.entity.name : 'HAWKIN DYNAMICS'}
            </Name>
            <Title>{props.title}</Title>
            <TemplateName>{props.templateName}</TemplateName>
            <Date>{props.timeframe}</Date>
          </EntityContainer>
        </ContentContainer>
      ) : null}
    </PdfHeaderWrapper>
  );
};

const PdfHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--color-surface-0);
`;

const ReportLogo = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 50%;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
`;

const Title = styled.div`
  flex: 0;
  font-weight: 300;
  letter-spacing: 0;
`;

const Date = styled.div``;
const TemplateName = styled.div``;

const Name = styled.div`
  font-weight: bold;
  letter-spacing: 0;
`;
const EntityContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;
